export class RestoreRedshiftRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "RedshiftRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRedshiftRequest.attributeTypeMap;
    }
    constructor() {
    }
}
